import {useState, useEffect} from "react";
import './App.css';

import RoutePath from "./routes/RoutePath";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {CartProvider} from './cart/cart-utils'
import { AuthProvider } from "./provider/AuthProvider";
import {SearchProvider} from "./ui/search/search.context.tsx"
import { GSTRatesProvider } from "./gst-rates/gst-rates";
import { SiteSettingProvider } from "./site-settings/site-settings";
import {ProductFilterProvider} from "./contexts/product-filter/product-filter.context.tsx";

import ScrollToTop from "react-scroll-to-top";
import { BiUpArrow } from "react-icons/bi";


function App() {
	const [theme, setTheme] = useState('light')
	useEffect(() => {
		
		//const rand_num = localStorage.getItem('rand_num')
		const rand_num = localStorage.getItem('rand_num')

		const theme = localStorage.getItem('theme')
		if(theme){
			setTheme(theme)
		}
		console.log("rand_num",rand_num);
		if(!rand_num){
			const min = 1000000000;
			const max = 9999999999;
			const rand = Math.floor(Math.random() * (max - min + 1)) + min;
			localStorage.setItem('rand_num',rand);
		}
	})

	
	return (
		<div dir="ltr" class={theme}>
			<div className="flex flex-col  transition-colors duration-150">
			<SiteSettingProvider>
			<ProductFilterProvider >
			<AuthProvider>
				<GSTRatesProvider>
					<CartProvider>
						<SearchProvider>
							<RoutePath />
						</SearchProvider> 
					</CartProvider>
				</GSTRatesProvider>
			</AuthProvider>
			</ProductFilterProvider>
			</SiteSettingProvider>
			</div>
			<ToastContainer theme="colored" />    
			<ScrollToTop smooth component={<BiUpArrow color='white' />} className="flex items-center justify-center" style={{backgroundColor:'#892DA0',bottom: '60px',
right: '15px'}} />
		</div>
	);
}

export default App;
